import { gql } from 'apollo-boost';

export const DOWNLOAD_URLMETA_VIDEO = gql`
    mutation($data: UploadUrlMetaMediaInput!) {
        downloadUrlMetaVideo(data: $data) {
            url
            name
            displayName
            type
            format
            size
            mime
        }
    }
`;
